import React from "react";

export default function AssessmentInstruction({ modal_data }) {
  const { assessmentType } = modal_data || {};

  const getInstructions = () => {
    switch (assessmentType) {
      case "bod2":
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Gambaran umum perusahaan dan Petunjuk pengisian
            </h3>

            <p>
              PT Farmasi Nusantara merupakan perusahaan farmasi nasional yang
              berperan strategis dalam penyediaan produk farmasi dan biologis,
              termasuk dukungan terhadap program kesehatan nasional. Dalam
              menghadapi dinamika industri, perusahaan terus mendorong
              peningkatan efisiensi operasional, kualitas layanan, kepatuhan
              regulasi, serta penguatan kapabilitas organisasi agar tetap
              berkelanjutan dan kompetitif.
            </p>

            <p>
              Anda saat ini berperan sebagai <b>Kepala Departemen (BOD-2)</b>{" "}
              yang memegang peran penting dalam menerjemahkan kebijakan dan
              arahan strategis Divisi ke dalam keputusan dan tindakan
              operasional di tingkat departemen. Anda diharapkan mampu
              menyeimbangkan tuntutan kinerja jangka pendek dengan kepentingan
              jangka menengah–panjang, serta mengelola tim, proses, dan risiko
              secara profesional dan bertanggung jawab.
            </p>

            <p>
              Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
              realistis yang mencerminkan tantangan manajerial di lingkungan PT
              Farmasi Nusantara. Setiap situasi diikuti oleh beberapa alternatif
              tindakan yang seluruhnya mungkin dilakukan, namun memiliki tingkat
              efektivitas yang berbeda.
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
            <p>Untuk setiap kasus yang disajikan:</p>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                <b>
                  Pilih satu tindakan yang menurut Anda PALING TEPAT (
                  <i>Best Action</i>)
                </b>
                <br />→ Tindakan yang paling mencerminkan efektivitas
                kepemimpinan, pertimbangan strategis, dan keselarasan dengan
                peran Kepala Departemen.
              </li>
              <li>
                <b>
                  Pilih satu tindakan yang menurut Anda PALING TIDAK TEPAT (
                  <i>Poor Action</i>)
                </b>
                <br />→ Tindakan yang paling lemah, berisiko, atau tidak sejalan
                dengan tuntutan peran dan konteks organisasi.
              </li>
            </ul>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>
              Petunjuk Penting:
            </h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                Jawablah berdasarkan pertimbangan Anda terhadap apa yang
                seharusnya dilakukan dalam konteks profesional.
              </li>
              <li>
                Pertimbangkan dampak keputusan terhadap kinerja, risiko, tim,
                lintas fungsi, serta arah strategis perusahaan.
              </li>
              <li>
                Tidak ada jawaban benar atau salah secara absolut, namun pilihan
                Anda akan mencerminkan pola pengambilan keputusan dan tingkat
                kompetensi kepemimpinan.
              </li>
            </ul>

            <p style={{ marginTop: 20, fontStyle: "italic" }}>
              Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah
              Anda benar-benar berada pada posisi tersebut di lingkungan kerja
              PT Farmasi Nusantara.
            </p>
          </div>
        );

      case "bod2-gap":
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Gambaran umum perusahaan dan Petunjuk pengisian
            </h3>

            <p>
              PT Nusantara Consumer Goods (NCG) merupakan perusahaan nasional di
              industri <i>Fast Moving Consumer Goods</i> (FMCG) yang berperan
              penting dalam menyediakan produk makanan atau kebutuhan
              sehari-hari masyarakat Indonesia. Dalam menghadapi dinamika pasar
              yang kompetitif, perubahan perilaku konsumen, serta tuntutan
              efisiensi dan inovasi yang berkelanjutan, perusahaan secara
              konsisten mendorong peningkatan kinerja operasional, kualitas
              eksekusi, serta penguatan kapabilitas organisasi agar tetap tumbuh
              dan berdaya saing.
            </p>

            <p>
              Anda saat ini berperan sebagai <b>Kepala Departemen (BOD-2)</b>{" "}
              yang memegang peran strategis dalam menerjemahkan kebijakan dan
              arahan Pimpinan PT NCG ke dalam rekomendasi serta tindakan
              operasional di tingkat Departemen. Pada posisi ini, Anda
              diharapkan mampu menyeimbangkan tuntutan kinerja jangka pendek
              dengan kepentingan jangka menengah–panjang perusahaan, sekaligus
              mengelola tim, proses, dan risiko secara efektif dan bertanggung
              jawab.
            </p>

            <p>
              Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
              realistis yang mencerminkan tantangan manajerial di lingkungan PT
              Nusantara Consumer Goods (NCG). Setiap situasi disertai dengan
              beberapa alternatif tindakan yang seluruhnya mungkin dilakukan,
              namun memiliki tingkat efektivitas dan risiko yang berbeda
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                <b>
                  Pilih satu tindakan yang menurut Anda PALING TEPAT sesuai
                  dengan masing-masing persoalan
                </b>
                <br />→ Pilihan terbaik adalah tindakan yang paling mencerminkan
                efektivitas kepemimpinan, ketepatan pengambilan keputusan, serta
                keselarasan dengan tujuan dan kepentingan organisasi, bukan
                sekadar tindakan yang paling mudah atau paling aman.
              </li>
            </ul>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>
              Petunjuk Penting:
            </h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                Jawablah berdasarkan apa yang seharusnya dilakukan dalam konteks
                profesional, bukan berdasarkan preferensi pribadi semata.
              </li>
              <li>
                Pertimbangkan dampak keputusan terhadap kinerja, risiko, tim,
                lintas fungsi, serta arah strategis perusahaan.
              </li>
              <li>
                Tidak ada jawaban benar atau salah secara absolut, namun pilihan
                Anda akan mencerminkan pola pengambilan keputusan dan tingkat
                kompetensi kepemimpinan.
              </li>
            </ul>

            <p style={{ marginTop: 20, fontStyle: "italic" }}>
              Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah
              Anda benar-benar berada pada posisi tersebut di lingkungan kerja
              PT Nusantara Consumer Goods (NCG).
            </p>
          </div>
        );

      case "bod3":
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Gambaran umum perusahaan dan Petunjuk pengisian
            </h3>

            <p>
              PT Farmasi Nusantara merupakan perusahaan farmasi nasional yang
              berperan strategis dalam penyediaan produk farmasi dan biologis,
              termasuk dukungan terhadap program kesehatan nasional. Dalam
              menghadapi dinamika industri, perusahaan terus mendorong
              peningkatan efisiensi operasional, kualitas layanan, kepatuhan
              regulasi, serta penguatan kapabilitas organisasi agar tetap
              berkelanjutan dan kompetitif.
            </p>

            <p>
              Anda saat ini berperan sebagai{" "}
              <b>Manajer atau Assistant Manager (BOD-3)</b> yang memiliki
              tanggung jawab strategis-operasional di tingkat unit. Anda
              diharapkan mampu menerjemahkan arahan divisi ke dalam tindakan
              operasional yang efektif, mengelola tim dan koordinasi lintas
              fungsi di level unit, serta mengambil keputusan yang mencerminkan
              pertimbangan efisiensi, kualitas, dan stabilitas operasional unit
              dalam jangka pendek hingga menengah.
            </p>

            <p>
              Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
              realistis yang mencerminkan tantangan manajerial di lingkungan PT
              Farmasi Nusantara. Setiap situasi diikuti oleh beberapa alternatif
              tindakan yang seluruhnya mungkin dilakukan, namun memiliki tingkat
              efektivitas yang berbeda.
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
            <p>Untuk setiap kasus yang disajikan:</p>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                <b>Pilih SATU tindakan yang menurut Anda PALING TEPAT</b>
                <br />→ Tindakan yang paling mencerminkan efektivitas
                kepemimpinan operasional, pertimbangan praktis, dan keselarasan
                dengan peran Manajer/Assistant Manager di tingkat unit.
              </li>
            </ul>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>
              Petunjuk Penting:
            </h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                Jawablah berdasarkan apa yang seharusnya dilakukan dalam konteks
                profesional, bukan berdasarkan preferensi pribadi semata.
              </li>
              <li>
                Pertimbangkan dampak keputusan terhadap:
                <ul style={{ marginTop: 5 }}>
                  <li>Kelancaran dan efektivitas operasional unit</li>
                  <li>
                    Kualitas hasil kerja dan kepatuhan terhadap standar serta
                    regulasi
                  </li>
                  <li>
                    Beban kerja, motivasi, dan kesiapan sumber daya manusia di
                    unit
                  </li>
                  <li>
                    Efektivitas koordinasi dan kolaborasi dengan unit lain
                  </li>
                  <li>
                    Stabilitas kinerja unit dalam jangka pendek hingga menengah
                    (3-12 bulan)
                  </li>
                </ul>
              </li>
              <li>
                Tidak ada jawaban benar atau salah secara absolut, namun pilihan
                Anda akan mencerminkan pola pengambilan keputusan dan tingkat
                kompetensi kepemimpinan operasional sesuai tuntutan jabatan
                BOD-3.
              </li>
            </ul>

            <p style={{ marginTop: 20, fontWeight: "bold" }}>
              Catatan Penting:
            </p>
            <p style={{ fontStyle: "italic" }}>
              Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah
              Anda benar-benar berada pada posisi Manajer tersebut di lingkungan
              kerja PT Farmasi Nusantara.
            </p>

            <p
              style={{ marginTop: 20, fontWeight: "bold", textAlign: "center" }}
            >
              Selamat mengerjakan!
            </p>
          </div>
        );

      case "bod3-gap":
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Gambaran umum perusahaan dan Petunjuk pengisian
            </h3>

            <p>
              PT Nusantara Consumer Goods (NCG) merupakan perusahaan lokal di
              industri kecantikan dan perawatan pribadi yang berperan penting
              dalam menyediakan produk Skincare, Hair Care, dan Personal Care
              untuk konsumen Indonesia. Dalam menghadapi persaingan pasar yang
              ketat, perubahan tren konsumen yang cepat, serta tuntutan inovasi
              dan efisiensi operasional yang berkelanjutan, perusahaan secara
              konsisten mendorong peningkatan kinerja, kualitas eksekusi, serta
              penguatan kapabilitas tim di semua lini agar tetap tumbuh dan
              kompetitif.
            </p>

            <p>
              Anda saat ini berperan sebagai <b>Manager (BOD-3)</b> yang
              memegang peran penting dalam menerjemahkan arahan dari Pimpinan/
              Kepala Departemen ke dalam tindakan operasional dan taktis di
              tingkat unit kerja. Pada posisi ini, Anda diharapkan mampu
              mengelola tim secara efektif, mengkoordinasikan lintas fungsi
              dalam unit, menyelesaikan masalah operasional secara proaktif,
              serta berkontribusi pada pencapaian target Departemen dengan baik.
            </p>

            <p>
              Dalam tes ini, Anda akan dihadapkan pada sejumlah situasi kerja
              realistis yang mencerminkan tantangan manajerial di lingkungan PT
              Nusantara Consumer Goods (NCG). Setiap situasi disertai dengan
              beberapa alternatif tindakan yang seluruhnya mungkin dilakukan,
              namun memiliki tingkat efektivitas yang berbeda.
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
            <p>
              Pilih satu tindakan yang menurut Anda PALING TEPAT sesuai dengan
              masing-masing situasi.
            </p>
            <p>
              Pilihan terbaik adalah tindakan yang paling mencerminkan
              efektivitas manajerial, ketepatan dalam mengelola tim dan proses,
              serta keselarasan dengan tujuan Unit dan Departemen, bukan sekadar
              tindakan yang paling mudah atau paling aman.
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>
              Petunjuk Penting:
            </h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                Pertimbangkan dampak keputusan terhadap kinerja tim, koordinasi
                lintas fungsi, serta pencapaian target unit kerja.
              </li>
              <li>
                Tidak ada jawaban benar atau salah secara absolut, namun pilihan
                Anda akan mencerminkan pola pengambilan keputusan dan tingkat
                kompetensi manajerial.
              </li>
            </ul>

            <p style={{ marginTop: 20, fontStyle: "italic" }}>
              Kerjakan setiap kasus secara cermat dan konsisten, seolah-olah
              Anda benar-benar berada pada posisi tersebut di lingkungan kerja
              PT Nusantara Consumer Goods (NCG).
            </p>
          </div>
        );

      case "lji_lite":
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Petunjuk pengisian Leadership Judgement Indicator - Lite
            </h3>

            <p>
              Tes ini bertujuan untuk mengukur kualitas pertimbangan (
              <i>judgement</i>) dan pengambilan keputusan Anda dalam situasi
              kepemimpinan yang berkaitan dengan pengelolaan individu maupun tim
              kerja.
            </p>

            <p>
              Anda akan dihadapkan pada sejumlah situasi yang umum dijumpai
              dalam konteks kepemimpinan di lingkungan kerja. Setiap situasi
              akan disertai dengan empat alternatif tindakan yang dapat
              dilakukan dalam merespons kondisi tersebut.
            </p>

            <p>
              Instrumen ini terdiri dari <b>15 situasi kepemimpinan</b>, di mana
              setiap situasi dirancang untuk menggambarkan tantangan pengambilan
              keputusan dalam konteks <i>people management</i> di lingkungan
              organisasi.
            </p>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>Tugas Anda:</h4>
            <ul style={{ textAlign: "left", lineHeight: "1.8" }}>
              <li>
                Untuk setiap situasi yang diberikan, Anda diminta untuk{" "}
                <b>memilih satu tindakan</b> yang menurut penilaian Anda
                merupakan respons yang <b>paling efektif dan paling tepat</b>{" "}
                untuk dilakukan dalam kondisi tersebut.
              </li>
              <li>
                Jawaban yang Anda pilih diharapkan mencerminkan tindakan yang
                paling mungkin Anda ambil dalam situasi nyata di lingkungan
                kerja, bukan tindakan yang dianggap paling ideal secara
                teoritis.
              </li>
              <li>
                Tidak terdapat jawaban yang secara mutlak benar atau salah;
                penilaian difokuskan pada kualitas <i>leadership judgement</i>{" "}
                yang tercermin dari keputusan yang Anda ambil.
              </li>
              <li>
                Seluruh soal wajib dijawab dalam batas waktu yang telah
                ditentukan.
              </li>
              <li>
                Anda tidak diperkenankan untuk mendiskusikan, merekam, menyalin,
                atau menyebarluaskan materi tes dalam bentuk apa pun.
              </li>
            </ul>

            <h4 style={{ marginTop: 20, color: "#78000F" }}>
              Waktu Pengerjaan:
            </h4>
            <p>
              Durasi waktu yang dialokasikan untuk mengerjakan seluruh soal
              adalah sekitar <b>12 – 15 menit</b>.
            </p>

            <p style={{ marginTop: 20, fontStyle: "italic" }}>
              Dengan memulai tes, Anda menyatakan telah memahami dan menyetujui
              seluruh ketentuan yang berlaku.
            </p>

            <p
              style={{ marginTop: 20, fontWeight: "bold", textAlign: "center" }}
            >
              Selamat mengerjakan!
            </p>
          </div>
        );

      default:
        return (
          <div>
            <h3 style={{ color: "#00abbd" }}>
              Gambaran umum perusahaan dan Petunjuk pengisian
            </h3>
            <p>Silakan pilih assessment yang sesuai.</p>
          </div>
        );
    }
  };

  return (
    <div>
      <div className="intruksi-modal">{getInstructions()}</div>
    </div>
  );
}
